export async function fetchDataSummaryData(
  token,
  setIsLoading,
  setFilteredRows,
  selectedSurveyId = "all",
  selectedTipeSurvey = "all",
  selectedArea = "all",
  selectedRegion = "all",
  selectedWilayah = "all",
  selectedRegencyId = "all",
  selectedDistrictId = "all",
  selectedSubDistrictId = "all",
  selectedUserNameSurveyor = "all",
  selectedPeriode = "all"
) {
  setFilteredRows([]);
  setIsLoading(true);

  // Create an empty URLSearchParams object
  const queryParams = new URLSearchParams();

  queryParams.append("is_area", "true");

  // Add selectedSurveyId to the query if it's provided
  if (selectedSurveyId && selectedSurveyId !== "all") {
    queryParams.append("survey_id", selectedSurveyId);
  }

  // Add selectedTipeSurvey to the query if it's provided
  if (selectedTipeSurvey && selectedTipeSurvey !== "all") {
    queryParams.append("tipe_survey", selectedTipeSurvey);
  }

  // Add selectedArea to the query if it's provided
  if (selectedArea && selectedArea !== "all") {
    queryParams.append("area", selectedArea);
  }

  // Add selectedRegion to the query if it's provided
  if (selectedRegion && selectedRegion !== "all") {
    queryParams.append("region_name", selectedRegion);
  }

  // Add selectedWilayah to the query if it's provided
  if (selectedWilayah && selectedWilayah !== "all") {
    queryParams.append("wilayah_name", selectedWilayah);
  }

  // Add selectedRegencyId to the query if it's provided
  if (selectedRegencyId && selectedRegencyId !== "all") {
    queryParams.append("regency_id", selectedRegencyId);
  }

  // Add selectedDistrictId to the query if it's provided
  if (selectedDistrictId && selectedDistrictId !== "all") {
    queryParams.append("district_id", selectedDistrictId);
  }

  // Add selectedSubDistrictId to the query if it's provided
  if (selectedSubDistrictId && selectedSubDistrictId !== "all") {
    queryParams.append("sub_district_id", selectedSubDistrictId);
  }

  if (selectedUserNameSurveyor && selectedUserNameSurveyor !== "all") {
    queryParams.append("user_name_surveyor", selectedUserNameSurveyor);
  }

  if (selectedPeriode && selectedPeriode !== "all") {
    queryParams.append("periode", selectedPeriode);
  }

  // Construct the full URL with query parameters
  const queryString = queryParams.toString();
  const apiUrl =
    `${process.env.REACT_APP_API_URL}/api/v1/dashboard/audit-summary` +
    (queryString ? `?${queryString}` : "");

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      const data = await response.json();
      setFilteredRows(data.data); // Initialize filteredRows with the retrieved data
    } else {
      setFilteredRows([]);
      // Handle error
    }
  } catch (error) {
    // Handle error
  }

  setIsLoading(false);
}

export async function fetchDataSummaryDataDev(
  token,
  setIsLoading,
  setFilteredRows,
  selectedSurveyId = "all",
  selectedTipeSurvey = "all",
  selectedArea = "all",
  selectedRegion = "all",
  selectedWilayah = "all",
  selectedRegencyId = "all",
  selectedDistrictId = "all",
  selectedSubDistrictId = "all",
  selectedUserNameSurveyor = "all",
  selectedPeriode = "all"
) {
  setFilteredRows([]);
  setIsLoading(true);

  // Create an empty URLSearchParams object
  const queryParams = new URLSearchParams();

  queryParams.append("is_area", "true");

  // Add selectedSurveyId to the query if it's provided
  if (selectedSurveyId && selectedSurveyId !== "all") {
    queryParams.append("survey_id", selectedSurveyId);
  }

  // Add selectedTipeSurvey to the query if it's provided
  if (selectedTipeSurvey && selectedTipeSurvey !== "all") {
    queryParams.append("tipe_survey", selectedTipeSurvey);
  }

  // Add selectedArea to the query if it's provided
  if (selectedArea && selectedArea !== "all") {
    queryParams.append("area", selectedArea);
  }

  // Add selectedRegion to the query if it's provided
  if (selectedRegion && selectedRegion !== "all") {
    queryParams.append("region_name", selectedRegion);
  }

  // Add selectedWilayah to the query if it's provided
  if (selectedWilayah && selectedWilayah !== "all") {
    queryParams.append("wilayah_name", selectedWilayah);
  }

  // Add selectedRegencyId to the query if it's provided
  if (selectedRegencyId && selectedRegencyId !== "all") {
    queryParams.append("regency_id", selectedRegencyId);
  }

  // Add selectedDistrictId to the query if it's provided
  if (selectedDistrictId && selectedDistrictId !== "all") {
    queryParams.append("district_id", selectedDistrictId);
  }

  // Add selectedSubDistrictId to the query if it's provided
  if (selectedSubDistrictId && selectedSubDistrictId !== "all") {
    queryParams.append("sub_district_id", selectedSubDistrictId);
  }

  if (selectedUserNameSurveyor && selectedUserNameSurveyor !== "all") {
    queryParams.append("user_name_surveyor", selectedUserNameSurveyor);
  }

  if (selectedPeriode && selectedPeriode !== "all") {
    queryParams.append("periode", selectedPeriode);
  }

  // Construct the full URL with query parameters
  const queryString = queryParams.toString();
  const apiUrl =
    `${process.env.REACT_APP_API_URL}/api/v1/dashboard/audit-summary` +
    (queryString ? `?${queryString}` : "");

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      const data = await response.json();
      setFilteredRows(data.data); // Initialize filteredRows with the retrieved data
    } else {
      setFilteredRows([]);
      // Handle error
    }
  } catch (error) {
    // Handle error
  }

  setIsLoading(false);
}

export async function fetchDataSummaryDataMaps(
  token,
  setIsLoading,
  setFilteredRows,
  selectedSurveyId = "all",
  selectedTipeSurvey = "all",
  selectedArea = "all",
  selectedRegion = "all",
  selectedWilayah = "all",
  selectedRegencyId = "all",
  selectedDistrictId = "all",
  selectedSubDistrictId = "all",
  selectedUserNameSurveyor = "all",
  selectedPeriode = "all"
) {
  setFilteredRows([]);
  setIsLoading(true);

  // Create an empty URLSearchParams object
  const queryParams = new URLSearchParams();

  queryParams.append("is_area", "false");

  // Add selectedSurveyId to the query if it's provided
  if (selectedSurveyId && selectedSurveyId !== "all") {
    queryParams.append("survey_id", selectedSurveyId);
  }

  // Add selectedTipeSurvey to the query if it's provided
  if (selectedTipeSurvey && selectedTipeSurvey !== "all") {
    queryParams.append("tipe_survey", selectedTipeSurvey);
  }

  // Add selectedArea to the query if it's provided
  if (selectedArea && selectedArea !== "all") {
    queryParams.append("area", selectedArea);
  }

  // Add selectedRegion to the query if it's provided
  if (selectedRegion && selectedRegion !== "all") {
    queryParams.append("region_name", selectedRegion);
  }

  // Add selectedWilayah to the query if it's provided
  if (selectedWilayah && selectedWilayah !== "all") {
    queryParams.append("wilayah_name", selectedWilayah);
  }

  // Add selectedRegencyId to the query if it's provided
  if (selectedRegencyId && selectedRegencyId !== "all") {
    queryParams.append("regency_id", selectedRegencyId);
  }

  // Add selectedDistrictId to the query if it's provided
  if (selectedDistrictId && selectedDistrictId !== "all") {
    queryParams.append("district_id", selectedDistrictId);
  }

  // Add selectedSubDistrictId to the query if it's provided
  if (selectedSubDistrictId && selectedSubDistrictId !== "all") {
    queryParams.append("sub_district_id", selectedSubDistrictId);
  }

  if (selectedUserNameSurveyor && selectedUserNameSurveyor !== "all") {
    queryParams.append("user_name_surveyor", selectedUserNameSurveyor);
  }

  if (selectedPeriode && selectedPeriode !== "all") {
    queryParams.append("periode", selectedPeriode);
  }

  // Construct the full URL with query parameters
  const queryString = queryParams.toString();
  const apiUrl =
    `${process.env.REACT_APP_API_URL}/api/v1/dashboard/audit-summary` +
    (queryString ? `?${queryString}` : "");

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      const data = await response.json();
      setFilteredRows(data.data); // Initialize filteredRows with the retrieved data
    } else {
      setFilteredRows([]);
      // Handle error
    }
  } catch (error) {
    // Handle error
  }

  setIsLoading(false);
}

export async function fetchDataSummaryDataMapsDev(
  token,
  setIsLoading,
  setFilteredRows,
  selectedSurveyId = "all",
  selectedTipeSurvey = "all",
  // selectedArea = "all",
  // selectedRegion = "all",
  // selectedWilayah = "all",
  // selectedProvinceId = "all",
  // selectedRegencyId = "all",
  // selectedDistrictId = "all",
  // selectedSubDistrictId = "all",
  selectedUserNameSurveyor = "all",
  selectedPeriode = "all"
) {
  setFilteredRows([]);
  setIsLoading(true);

  // Create an empty URLSearchParams object
  const queryParams = new URLSearchParams();

  queryParams.append("is_area", "true");

  // Add selectedSurveyId to the query if it's provided
  if (selectedSurveyId && selectedSurveyId !== "all") {
    queryParams.append("survey_id", selectedSurveyId);
  }

  // Add selectedTipeSurvey to the query if it's provided
  if (selectedTipeSurvey && selectedTipeSurvey !== "all") {
    queryParams.append("tipe_survey", selectedTipeSurvey);
  }

  // // Add selectedArea to the query if it's provided
  // if (selectedArea && selectedArea !== "all") {
  //   queryParams.append("area", selectedArea);
  // }

  // // Add selectedRegion to the query if it's provided
  // if (selectedRegion && selectedRegion !== "all") {
  //   queryParams.append("region_name", selectedRegion);
  // }

  // // Add selectedWilayah to the query if it's provided
  // if (selectedWilayah && selectedWilayah !== "all") {
  //   queryParams.append("wilayah_name", selectedWilayah);
  // }

  // // Add selectedProvinceId to the query if it's provided
  // if (selectedProvinceId && selectedProvinceId !== "all") {
  //   queryParams.append("province_id", selectedProvinceId);
  // }

  // // Add selectedRegencyId to the query if it's provided
  // if (selectedRegencyId && selectedRegencyId !== "all") {
  //   queryParams.append("regency_id", selectedRegencyId);
  // }

  // // Add selectedDistrictId to the query if it's provided
  // if (selectedDistrictId && selectedDistrictId !== "all") {
  //   queryParams.append("district_id", selectedDistrictId);
  // }

  // // Add selectedSubDistrictId to the query if it's provided
  // if (selectedSubDistrictId && selectedSubDistrictId !== "all") {
  //   queryParams.append("sub_district_id", selectedSubDistrictId);
  // }

  if (selectedUserNameSurveyor && selectedUserNameSurveyor !== "all") {
    queryParams.append("user_name_surveyor", selectedUserNameSurveyor);
  }

  if (selectedPeriode && selectedPeriode !== "all") {
    queryParams.append("periode", selectedPeriode);
  }

  // Construct the full URL with query parameters
  const queryString = queryParams.toString();
  const apiUrl =
    `${process.env.REACT_APP_API_URL}/api/v1/dashboard/audit-summary` +
    (queryString ? `?${queryString}` : "");

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      const data = await response.json();
      setFilteredRows(data.data); // Initialize filteredRows with the retrieved data
    } else {
      setFilteredRows([]);
      // Handle error
    }
  } catch (error) {
    // Handle error
  }

  setIsLoading(false);
}

export async function fetchDataStatData(
  token,
  setIsLoading,
  setFilteredRows,
  selectedSurveyId = "all",
  selectedTipeSurvey = "all",
  selectedArea = "all",
  selectedRegion = "all",
  selectedWilayah = "all",
  selectedRegencyId = "all",
  selectedDistrictId = "all",
  selectedSubDistrictId = "all",
  selectedUserNameSurveyor = "all"
) {
  setFilteredRows([]);
  setIsLoading(true);

  // Create an empty URLSearchParams object
  const queryParams = new URLSearchParams();

  // Add selectedSurveyId to the query if it's provided
  if (selectedSurveyId && selectedSurveyId !== "all") {
    queryParams.append("survey_id", selectedSurveyId);
  }

  // Add selectedTipeSurvey to the query if it's provided
  if (selectedTipeSurvey && selectedTipeSurvey !== "all") {
    queryParams.append("tipe_survey", selectedTipeSurvey);
  }

  // Add selectedArea to the query if it's provided
  if (selectedArea && selectedArea !== "all") {
    queryParams.append("area", selectedArea);
  }

  // Add selectedRegion to the query if it's provided
  if (selectedRegion && selectedRegion !== "all") {
    queryParams.append("region_name", selectedRegion);
  }

  // Add selectedWilayah to the query if it's provided
  if (selectedWilayah && selectedWilayah !== "all") {
    queryParams.append("wilayah_name", selectedWilayah);
  }

  // Add selectedRegencyId to the query if it's provided
  if (selectedRegencyId && selectedRegencyId !== "all") {
    queryParams.append("regency_id", selectedRegencyId);
  }

  // Add selectedDistrictId to the query if it's provided
  if (selectedDistrictId && selectedDistrictId !== "all") {
    queryParams.append("district_id", selectedDistrictId);
  }

  // Add selectedSubDistrictId to the query if it's provided
  if (selectedSubDistrictId && selectedSubDistrictId !== "all") {
    queryParams.append("sub_district_id", selectedSubDistrictId);
  }

  // Add selectedUserNameSurveyor to the query if it's provided
  if (selectedUserNameSurveyor && selectedUserNameSurveyor !== "all") {
    queryParams.append("user_name_surveyor", selectedUserNameSurveyor);
  }

  // Construct the full URL with query parameters
  const queryString = queryParams.toString();
  const apiUrl =
    `${process.env.REACT_APP_API_URL}/api/v1/dashboard/stat` +
    (queryString ? `?${queryString}` : "");

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      const { data } = await response.json();
      const statusData = data[0];
      const formattedData = [
        {
          audit_status: "Total Store",
          count_audit_status: statusData.total_plan || 0,
          percentage: "",
        },
      ];

      if (
        statusData.audit_not_started &&
        statusData.audit_not_started.count > 0
      ) {
        formattedData.push({
          audit_status: "Not Started",
          count_audit_status: statusData.audit_not_started.count,
          percentage: statusData.audit_not_started.percentage || "0%",
        });
      }

      if (
        statusData.audit_on_progress &&
        statusData.audit_on_progress.count > 0
      ) {
        formattedData.push({
          audit_status: "On Progress",
          count_audit_status: statusData.audit_on_progress.count,
          percentage: statusData.audit_on_progress.percentage || "0%",
        });
      }

      if (statusData.audit_valid && statusData.audit_valid.count > 0) {
        formattedData.push({
          audit_status: "Valid",
          count_audit_status: statusData.audit_valid.count,
          percentage: statusData.audit_valid.percentage || "0%",
        });
      }

      if (statusData.audit_closed && statusData.audit_closed.count > 0) {
        formattedData.push({
          audit_status: "Closed",
          count_audit_status: statusData.audit_closed.count,
          percentage: statusData.audit_closed.percentage || "0%",
        });
      }

      if (formattedData.length > 0) {
        setFilteredRows(formattedData);
      } else {
        setFilteredRows([]);
      }
    } else {
      setFilteredRows([]);
      // Handle error
    }
  } catch (error) {
    // Handle error
  }

  setIsLoading(false);
}

export async function fetchDataStatDataDev(
  token,
  setIsLoading,
  setFilteredRows,
  selectedSurveyId = "all",
  selectedTipeSurvey = "all",
  selectedArea = "all",
  selectedRegion = "all",
  selectedWilayah = "all",
  selectedRegencyId = "all",
  selectedDistrictId = "all",
  selectedSubDistrictId = "all",
  selectedUserNameSurveyor = "all"
) {
  setFilteredRows([]);
  setIsLoading(true);

  // Create an empty URLSearchParams object
  const queryParams = new URLSearchParams();

  // Add selectedSurveyId to the query if it's provided
  if (selectedSurveyId && selectedSurveyId !== "all") {
    queryParams.append("survey_id", selectedSurveyId);
  }

  // Add selectedTipeSurvey to the query if it's provided
  if (selectedTipeSurvey && selectedTipeSurvey !== "all") {
    queryParams.append("tipe_survey", selectedTipeSurvey);
  }

  // Add selectedArea to the query if it's provided
  if (selectedArea && selectedArea !== "all") {
    queryParams.append("area", selectedArea);
  }

  // Add selectedRegion to the query if it's provided
  if (selectedRegion && selectedRegion !== "all") {
    queryParams.append("region_name", selectedRegion);
  }

  // Add selectedWilayah to the query if it's provided
  if (selectedWilayah && selectedWilayah !== "all") {
    queryParams.append("wilayah_name", selectedWilayah);
  }

  // Add selectedRegencyId to the query if it's provided
  if (selectedRegencyId && selectedRegencyId !== "all") {
    queryParams.append("regency_id", selectedRegencyId);
  }

  // Add selectedDistrictId to the query if it's provided
  if (selectedDistrictId && selectedDistrictId !== "all") {
    queryParams.append("district_id", selectedDistrictId);
  }

  // Add selectedSubDistrictId to the query if it's provided
  if (selectedSubDistrictId && selectedSubDistrictId !== "all") {
    queryParams.append("sub_district_id", selectedSubDistrictId);
  }

  // Add selectedUserNameSurveyor to the query if it's provided
  if (selectedUserNameSurveyor && selectedUserNameSurveyor !== "all") {
    queryParams.append("user_name_surveyor", selectedUserNameSurveyor);
  }

  // Construct the full URL with query parameters
  const queryString = queryParams.toString();
  const apiUrl =
    `${process.env.REACT_APP_API_URL}/api/v1/dashboard/stat` +
    (queryString ? `?${queryString}` : "");

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      const { data } = await response.json();
      const statusData = data[0];
      const formattedData = [
        {
          audit_status: "Total Store",
          count_audit_status: statusData.total_plan || 0,
          percentage: "",
        },
      ];

      if (
        statusData.audit_not_started &&
        statusData.audit_not_started.count > 0
      ) {
        formattedData.push({
          audit_status: "Not Started",
          count_audit_status: statusData.audit_not_started.count,
          percentage: statusData.audit_not_started.percentage || "0%",
        });
      }

      if (
        statusData.audit_on_progress &&
        statusData.audit_on_progress.count > 0
      ) {
        formattedData.push({
          audit_status: "On Progress",
          count_audit_status: statusData.audit_on_progress.count,
          percentage: statusData.audit_on_progress.percentage || "0%",
        });
      }

      if (statusData.audit_valid && statusData.audit_valid.count > 0) {
        formattedData.push({
          audit_status: "Valid",
          count_audit_status: statusData.audit_valid.count,
          percentage: statusData.audit_valid.percentage || "0%",
        });
      }

      if (statusData.audit_closed && statusData.audit_closed.count > 0) {
        formattedData.push({
          audit_status: "Closed",
          count_audit_status: statusData.audit_closed.count,
          percentage: statusData.audit_closed.percentage || "0%",
        });
      }

      if (formattedData.length > 0) {
        setFilteredRows(formattedData);
      } else {
        setFilteredRows([]);
      }
    } else {
      setFilteredRows([]);
      // Handle error
    }
  } catch (error) {
    // Handle error
  }

  setIsLoading(false);
}

export async function fetchDataDailyTrendData(
  token,
  setIsLoading,
  setDatagrafik,
  Highcharts,
  selectedSurveyId = "all",
  selectedTipeSurvey = "all",
  selectedArea = "all",
  selectedRegion = "all",
  selectedWilayah = "all",
  selectedRegencyId = "all",
  selectedDistrictId = "all",
  selectedSubDistrictId = "all",
  selectedUserNameSurveyor = "all",
  selectedDatestart,
  selectedDateend,
  setSelectedDateFirst,
  setSelectedDateLast,
  setFilteredData
) {
  setIsLoading(true);

  // Create an empty URLSearchParams object
  const queryParams = new URLSearchParams();

  // Add selectedSurveyId to the query if it's provided
  if (selectedSurveyId && selectedSurveyId !== "all") {
    queryParams.append("survey_id", selectedSurveyId);
  }
  // Add selectedTipeSurvey to the query if it's provided
  if (selectedTipeSurvey && selectedTipeSurvey !== "all") {
    queryParams.append("tipe_survey", selectedTipeSurvey);
  }
  // Add selectedArea to the query if it's provided
  if (selectedArea && selectedArea !== "all") {
    queryParams.append("area", selectedArea);
  }

  // Add selectedRegion to the query if it's provided
  if (selectedRegion && selectedRegion !== "all") {
    queryParams.append("region_name", selectedRegion);
  }

  // Add selectedWilayah to the query if it's provided
  if (selectedWilayah && selectedWilayah !== "all") {
    queryParams.append("wilayah_name", selectedWilayah);
  }

  // Add selectedRegencyId to the query if it's provided
  if (selectedRegencyId && selectedRegencyId !== "all") {
    queryParams.append("regency_id", selectedRegencyId);
  }

  // Add selectedDistrictId to the query if it's provided
  if (selectedDistrictId && selectedDistrictId !== "all") {
    queryParams.append("district_id", selectedDistrictId);
  }

  // Add selectedSubDistrictId to the query if it's provided
  if (selectedSubDistrictId && selectedSubDistrictId !== "all") {
    queryParams.append("sub_district_id", selectedSubDistrictId);
  }

  // Add selectedUserNameSurveyor to the query if it's provided
  if (selectedUserNameSurveyor && selectedUserNameSurveyor !== "all") {
    queryParams.append("user_name_surveyor", selectedUserNameSurveyor);
  }

  if (selectedDatestart && selectedDatestart !== "all") {
    queryParams.append("start_date", selectedDatestart);
  }

  if (selectedDateend && selectedDateend !== "all") {
    queryParams.append("end_date", selectedDateend);
  }

  // Construct the full URL with query parameters
  const queryString = queryParams.toString();
  const apiUrl =
    `${process.env.REACT_APP_API_URL}/api/v1/dashboard/daily-trend` +
    (queryString ? `?${queryString}` : "");

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      const { data } = await response.json();
      if (data && data.length > 0) {
        const categories = data.map((item) => {
          const date = new Date(item.date_of_data_collected);
          const month = date.toLocaleString("en-US", { month: "long" });
          const day = date.getDate();
          const year = date.getFullYear();
          return `${day} ${month} ${year}`;
        });
        const validData = data.map((item) => item.store_valid_count);
        const closedData = data.map((item) => item.store_closed_count);

        const filteredReachChartOption = {
          chart: {
            type: "line",
            renderTo: "daily-trend-chart",
          },
          title: {
            text: "",
          },
          xAxis: {
            categories: categories,
          },
          yAxis: {
            title: {
              text: "",
            },
          },
          series: [
            {
              name: "Closed",
              data: closedData,
              color: "#DF2E38",
            },
            {
              name: "Valid",
              data: validData,
              color: "#5D9C59",
            },
          ],
        };

        Highcharts.chart("daily-trend-chart", filteredReachChartOption);

        setDatagrafik(data);

        // useEffect(() => {
        // Memastikan bahwa Datagrafik telah diambil dari API sebelum memperbarui selectedDateFirst dan selectedDateLast
        if (data.length > 0) {
          setSelectedDateFirst(data[0].date_of_data_collected);
          setSelectedDateLast(data[data.length - 1].date_of_data_collected);
          setFilteredData(data);
        }
        // }, [Datagrafik]);
      } else {
        setDatagrafik([]);
        setFilteredData([]);
      }
    } else {
      // Jika response tidak ok, hapus chart dan kosongkan data
      setDatagrafik([]);
      setFilteredData([]);
    }
  } catch (error) {
    // Handle error
  }

  setIsLoading(false);
}

export async function fetchDataDailyTrendDataDev(
  token,
  setIsLoading,
  setDatagrafik,
  Highcharts,
  selectedSurveyId = "all",
  selectedTipeSurvey = "all",
  selectedArea = "all",
  selectedRegion = "all",
  selectedWilayah = "all",
  selectedRegencyId = "all",
  selectedDistrictId = "all",
  selectedSubDistrictId = "all",
  selectedUserNameSurveyor = "all",
  selectedDatestart,
  selectedDateend,
  setSelectedDateFirst,
  setSelectedDateLast,
  setFilteredData
) {
  setIsLoading(true);

  // Create an empty URLSearchParams object
  const queryParams = new URLSearchParams();

  // Add selectedSurveyId to the query if it's provided
  if (selectedSurveyId && selectedSurveyId !== "all") {
    queryParams.append("survey_id", selectedSurveyId);
  }
  // Add selectedTipeSurvey to the query if it's provided
  if (selectedTipeSurvey && selectedTipeSurvey !== "all") {
    queryParams.append("tipe_survey", selectedTipeSurvey);
  }
  // Add selectedArea to the query if it's provided
  if (selectedArea && selectedArea !== "all") {
    queryParams.append("area", selectedArea);
  }

  // Add selectedRegion to the query if it's provided
  if (selectedRegion && selectedRegion !== "all") {
    queryParams.append("region_name", selectedRegion);
  }

  // Add selectedWilayah to the query if it's provided
  if (selectedWilayah && selectedWilayah !== "all") {
    queryParams.append("wilayah_name", selectedWilayah);
  }

  // Add selectedRegencyId to the query if it's provided
  if (selectedRegencyId && selectedRegencyId !== "all") {
    queryParams.append("regency_id", selectedRegencyId);
  }

  // Add selectedDistrictId to the query if it's provided
  if (selectedDistrictId && selectedDistrictId !== "all") {
    queryParams.append("district_id", selectedDistrictId);
  }

  // Add selectedSubDistrictId to the query if it's provided
  if (selectedSubDistrictId && selectedSubDistrictId !== "all") {
    queryParams.append("sub_district_id", selectedSubDistrictId);
  }

  // Add selectedUserNameSurveyor to the query if it's provided
  if (selectedUserNameSurveyor && selectedUserNameSurveyor !== "all") {
    queryParams.append("user_name_surveyor", selectedUserNameSurveyor);
  }

  if (selectedDatestart && selectedDatestart !== "all") {
    queryParams.append("start_date", selectedDatestart);
  }

  if (selectedDateend && selectedDateend !== "all") {
    queryParams.append("end_date", selectedDateend);
  }

  // Construct the full URL with query parameters
  const queryString = queryParams.toString();
  const apiUrl =
    `${process.env.REACT_APP_API_URL}/api/v1/dashboard/daily-trend` +
    (queryString ? `?${queryString}` : "");

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      const { data } = await response.json();
      if (data && data.length > 0) {
        const categories = data.map((item) => {
          const date = new Date(item.date_of_data_collected);
          const month = date.toLocaleString("en-US", { month: "long" });
          const day = date.getDate();
          const year = date.getFullYear();
          return `${day} ${month} ${year}`;
        });
        const validData = data.map((item) => item.store_valid_count);
        const closedData = data.map((item) => item.store_closed_count);

        const filteredReachChartOption = {
          chart: {
            type: "line",
            renderTo: "daily-trend-chart",
          },
          title: {
            text: "",
          },
          xAxis: {
            categories: categories,
          },
          yAxis: {
            title: {
              text: "",
            },
          },
          series: [
            {
              name: "Closed",
              data: closedData,
              color: "#DF2E38",
            },
            {
              name: "Valid",
              data: validData,
              color: "#5D9C59",
            },
          ],
        };

        Highcharts.chart("daily-trend-chart", filteredReachChartOption);

        setDatagrafik(data);

        // useEffect(() => {
        // Memastikan bahwa Datagrafik telah diambil dari API sebelum memperbarui selectedDateFirst dan selectedDateLast
        if (data.length > 0) {
          setSelectedDateFirst(data[0].date_of_data_collected);
          setSelectedDateLast(data[data.length - 1].date_of_data_collected);
          setFilteredData(data);
        }
        // }, [Datagrafik]);
      } else {
        setDatagrafik([]);
        setFilteredData([]);
      }
    } else {
      // Jika response tidak ok, hapus chart dan kosongkan data
      setDatagrafik([]);
      setFilteredData([]);
    }
  } catch (error) {
    // Handle error
  }

  setIsLoading(false);
}

export async function fetchAreasFormatted(token, setDataArea) {
  setDataArea([]);
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/v1/area-breakdown`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      const { data } = await response.json();
      const newArray = data.map((item) => ({
        label: item.area,
        id: item.area,
      }));

      setDataArea(newArray);
    } else {
      setDataArea([]);
    }
  } catch (error) {
    console.error(error);
  }
}

export async function fetchProvincesFormatted(token, setDataProvinces) {
  setDataProvinces([]);
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/v1/province`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      const { data } = await response.json();
      const newArray = data.map((item) => ({
        label: item.name,
        id: item.code,
      }));

      setDataProvinces(newArray);
    } else {
      setDataProvinces([]);
    }
  } catch (error) {
    console.error(error);
  }
}

export async function fetchRegenciesFormatted(token, area, setDataRegency) {
  setDataRegency([]);
  if (area && area !== "all") {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/regency?area=${area}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        const { data } = await response.json();
        const newArray = data.map((item) => ({
          label: item.name,
          id: item.code,
          province_code: item.province?.code,
        }));

        setDataRegency(newArray);
      } else {
        setDataRegency([]);
      }
    } catch (error) {
      console.error(error);
    }
  }
}

export async function fetchRegionFormatted(token, setDataRegion) {
  setDataRegion([]);
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/v1/region`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      const { data } = await response.json();
      const newArray = data.map((item) => ({
        label: item.name,
        id: item.name,
      }));

      setDataRegion(newArray);
    } else {
      setDataRegion([]);
    }
  } catch (error) {
    console.error(error);
  }
}

export async function fetchWilayahFormatted(token, setDataWilayah) {
  setDataWilayah([]);
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/v1/wilayah`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      const { data } = await response.json();
      const newArray = data.map((item) => ({
        label: item.name,
        id: item.name,
      }));

      setDataWilayah(newArray);
    } else {
      setDataWilayah([]);
    }
  } catch (error) {
    console.error(error);
  }
}

export async function fetchDistrictFormatted(
  token,
  regencyCode,
  setDataDistrict
) {
  setDataDistrict([]);
  if (regencyCode && regencyCode !== "all") {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/district?regency_code=${regencyCode}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        const { data } = await response.json();
        const newArray = data.map((item) => ({
          label: item.name,
          id: item.code,
        }));

        setDataDistrict(newArray);
      } else {
        setDataDistrict([]);
      }
    } catch (error) {
      console.error(error);
    }
  }
}

export async function fetchSubDistrictFormatted(
  token,
  districtCode,
  setDataSubDistrict
) {
  setDataSubDistrict([]);
  if (districtCode && districtCode !== "all") {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/sub-district?district_code=${districtCode}&need_detail_info=false`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        const { data } = await response.json();
        const newArray = data.map((item) => ({
          label: item.name,
          id: item.code,
        }));

        setDataSubDistrict(newArray);
      } else {
        setDataSubDistrict([]);
      }
    } catch (error) {
      console.error(error);
    }
  }
}

export async function fetchPeriodeFormatted(token, setDataPeriode) {
  setDataPeriode([]);
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/v1/project/period`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.ok) {
      const data = await response.json();
      const newArray = data.data.map((item) => ({
        label: item.period.toString(), // Mengonversi period menjadi string
        id: item.period.toString(),
      }));
      setDataPeriode(newArray);
    } else {
      setDataPeriode([]);
    }
  } catch (error) {
    console.error(error);
  }
}

export async function fetchProjectFormatted(
  token,
  periodeCode,
  setDataProject,
  setDatadateend,
  setDatadatestart
) {
  setDataProject([]);
  if (periodeCode && periodeCode !== "all") {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/project?period=${periodeCode}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        const { data } = await response.json();

        const newArray = data.map((item) => ({
          label: item.project_name,
          id: item.survey_id,
          project_type_id: item.project_type_id,
          project_start_at: item.project_start_at,
          project_end_at: item.project_end_at,
        }));
        setDataProject(newArray);
      } else {
        setDataProject([]);
      }
    } catch (error) {
      console.error(error);
    }
  }
}
